import { asActivityLabel, type ActivityLabel } from "./activity-label";

/** Native tool rows store the CLI's "Using <tool>" text; the step shows the
 *  backend's user-facing `tool_label` instead, never the raw tool name. An
 *  unlabelled row stays empty so the step renders its generic fallback. */
export function nativeToolStepText(
  metadata: Record<string, unknown> | undefined,
  text: string,
): string {
  if (!metadata?.native_message_id || metadata.activity_kind !== "tool_call")
    return text;
  const label = metadata.tool_label;
  return typeof label === "string" ? label.trim() : "";
}

/** The step's label in the app language: `tool_label_key` on a native tool
 *  row, `label` on a tool row from the activity history. */
export function toolStepLabel(
  metadata: Record<string, unknown> | undefined,
): ActivityLabel | undefined {
  if (metadata?.activity_kind !== "tool_call") return undefined;
  return asActivityLabel(
    metadata.native_message_id ? metadata.tool_label_key : metadata.label,
  );
}
